/* eslint-disable class-methods-use-this */
/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *           _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../../common/error.service';

/**
 * Our http error interceptor that handles error.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  /**
   * Default Constructor.
   */
  constructor(private injector : Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
      if (error?.url) {
        // We only want to capture 400 and 403, because the built-in interceptor will capture other failures
        if (error.status === 400 || error.status === 403) {
          if (request.url.endsWith('share') && error.error.developerMessage === 'server_error_body_code') {
            console.log('we will not capture this 403 error in sentry as it is valid response:', request.url);
          }
          if (request.url.startsWith('/b/rest/resumes')) {
            // eslint-disable-next-line no-console
            console.log('we will not capture this 403 error in sentry as it is valid response:', request.url);
          } else {
            const errorService = this.injector.get(ErrorService);
            errorService.captureAngularHttpError(request, error);
          }
        }
      }
      return throwError(error);
    }));
  }
}
